module.exports = __webpack_public_path__ + "static/media/cylinder.9b82d7d2.svg";